import type { BeautyFilterMenuItem, BeautyItem, MakeupItem, MoodItem, StickerItem, BackgroundItem } from 'types/beautyFilter';

const BEAUTY_KEYS: string[] = ['preset', 'face', 'eyes', 'nose', 'lips', 'eyebrows'];
const MAKEUP_KEYS: string[] = ['makeup_foundation', 'makeup_blush', 'makeup_lipstick', 'makeup_highlighter', 'makeup_eyeshadow', 'makeup_eyebrows'];
const BACKGROUND_KEYS: string[] = ['Blur', 'HOME01', 'HOME02'];
const MOOD_KEYS: string[] = [
  'se_hudson',
  'be_default',
  'se_walden',
  'se_fairytale',
  'se_brannan',
  'se_1977',
  'se_toaster2',
  'se_rise',
  'se_skinwhiten',
  'se_inkwell',
  'se_snow_disposablecamera',
  'se_snow_toycamera',
  'se_snow_filmblue',
  'se_snow_filmold',
];
const STICKER_KEYS: string[] = [
  'bling_rabbit',
  'freckles_bungirl',
  'mini_flower_coronet',
  'cute_choco_hair',
  'think',
  'christmas_cat',
  'christmas_snow',
  'marker_dog',
  'cn_black_line_cat',
  'cn_white_choker_tiger_no_choker',
  'floral_pattern_cat',
  'cherry_blossom_rabbit',
  'rabbit_meitu',
  'red_nose_rabbit',
  'transperency_pink_neon_rabbit',
  'mint_rabbit',
  'mirrorball_bear',
  'wolfgang',
  'dandelion_corolla',
  'heart_waterdrop_mouse',
  'fruit_line_cat',
  'glassesdrawing',
  'love_cheek',
  'marker_tiny_hearts',
  'pink_heart_blush',
  'lip_orange',
  'lip_pink',
  'lip_red',
];

const BEAUTY_TABLE: { [key: string]: BeautyItem } = {
  preset: {
    id: 'preset',
    brscName: 'beauty_filter_quick', // 자동보정
    thumbnail: '/imgweb/beauty_filter/beauty/preset.svg',
    subKeys: ['preset'],
    subTable: {
      preset: {
        id: 'preset',
        brscName: 'beauty_filter_quick',
        thumbnail: '/imgweb/beauty_filter/beauty/preset.svg',
        range: [0, 100],
      },
    },
  },
  face: {
    id: 'face',
    brscName: 'beauty_filter_face', // 얼굴
    thumbnail: '/imgweb/beauty_filter/beauty/face.svg',
    subKeys: ['cheekbones_narrowing', 'narrowing', 'cheeks_narrowing', 'jaw_narrowing', 'jaw_wide_thin', 'chin_narrowing', 'chin_shortening', 'chin', 'forehead'],
    subTable: {
      cheekbones_narrowing: {
        id: 'cheekbones_narrowing',
        brscName: 'beauty_filter_cheekbone', // 광대뼈
        thumbnail: '/imgweb/beauty_filter/beauty/face/cheekbone.svg',
        range: [-1, 1],
      },
      narrowing: {
        id: 'narrowing',
        brscName: 'beauty_filter_reduce', // 축소
        thumbnail: '/imgweb/beauty_filter/beauty/face/face-reduce.svg',
        range: [0, 1],
      },
      cheeks_narrowing: {
        id: 'cheeks_narrowing',
        brscName: 'beauty_filter_cheek', // 볼
        thumbnail: '/imgweb/beauty_filter/beauty/face/cheek.svg',
        range: [0, 1],
      },
      jaw_narrowing: {
        id: 'jaw_narrowing',
        brscName: 'beauty_filter_slim', // 갸름한
        thumbnail: '/imgweb/beauty_filter/beauty/face/slender.svg',
        range: [0, 1],
      },
      jaw_wide_thin: {
        id: 'jaw_wide_thin',
        brscName: 'beauty_filter_angular', // 각진
        thumbnail: '/imgweb/beauty_filter/beauty/face/jaw.svg',
        range: [0, 1],
      },
      chin_narrowing: {
        id: 'chin_narrowing',
        brscName: 'beauty_filter_pointed', // 뾰족한
        thumbnail: '/imgweb/beauty_filter/beauty/face/pointed-chin.svg',
        range: [0, 1],
      },
      chin_shortening: {
        id: 'chin_shortening',
        brscName: 'beauty_filter_short', // 짧은
        thumbnail: '/imgweb/beauty_filter/beauty/face/chin.svg',
        range: [0, 1],
      },
      chin: {
        id: 'chin',
        brscName: 'beauty_filter_philtrum', // 인중
        thumbnail: '/imgweb/beauty_filter/beauty/face/philtrum.svg',
        range: [0, 1],
      },
      forehead: {
        id: 'forehead',
        brscName: 'beauty_filter_forehead', // 이마
        thumbnail: '/imgweb/beauty_filter/beauty/face/forehead.svg',
        range: [0, 1],
      },
    },
  },
  eyes: {
    id: 'eyes',
    brscName: 'beauty_filter_eye', // 눈
    thumbnail: '/imgweb/beauty_filter/beauty/eye.svg',
    subKeys: ['enlargement', 'spacing', 'height', 'rounding', 'lower_eyelid_pos', 'lower_eyelid_size'],
    subTable: {
      enlargement: {
        id: 'enlargement',
        brscName: 'beauty_filter_size', // 크기
        thumbnail: '/imgweb/beauty_filter/beauty/eyes/eye-size.svg',
        range: [0, 1],
      },
      spacing: {
        id: 'spacing',
        brscName: 'beauty_filter_spacing', // 간격
        thumbnail: '/imgweb/beauty_filter/beauty/eyes/eye-spacing.svg',
        range: [-1, 1],
      },
      height: {
        id: 'height',
        brscName: 'beauty_filter_height', // 높이
        thumbnail: '/imgweb/beauty_filter/beauty/eyes/eye-spacing.svg',
        range: [-1, 1],
      },
      rounding: {
        id: 'rounding',
        brscName: 'beauty_filter_pupil', // 눈동자
        thumbnail: '/imgweb/beauty_filter/beauty/eyes/pupil.svg',
        range: [0, 1],
      },
      lower_eyelid_pos: {
        id: 'lower_eyelid_pos',
        brscName: 'beauty_filter_lower', // 아래쪽
        brscSubName: 'beauty_filter_eye', // 눈
        thumbnail: '/imgweb/beauty_filter/beauty/eyes/eye-bottom.svg',
        range: [-1, 1],
      },
      lower_eyelid_size: {
        id: 'lower_eyelid_size',
        brscName: 'beauty_filter_upper', // 위쪽
        brscSubName: 'beauty_filter_eye', // 눈
        thumbnail: '/imgweb/beauty_filter/beauty/eyes/eye-top.svg',
        range: [-1, 1],
      },
    },
  },
  nose: {
    id: 'nose',
    brscName: 'beauty_filter_nose', // 코
    thumbnail: '/imgweb/beauty_filter/beauty/nose.svg',
    subKeys: ['length', 'width', 'tip_width', 'sellion'],
    subTable: {
      length: {
        id: 'length',
        brscName: 'beauty_filter_length', // 길이
        thumbnail: '/imgweb/beauty_filter/beauty/nose/nose-length.svg',
        range: [-1, 1],
      },
      width: {
        id: 'width',
        brscName: 'beauty_filter_size', // 크기
        thumbnail: '/imgweb/beauty_filter/beauty/nose/nose-size.svg',
        range: [-1, 1],
      },
      tip_width: {
        id: 'tip_width',
        brscName: 'beauty_filter_width', // 넓이
        thumbnail: '/imgweb/beauty_filter/beauty/nose/nose-enlarge.svg',
        range: [0, 1],
      },
      sellion: {
        id: 'sellion',
        brscName: 'beauty_filter_reduce', // 축소
        thumbnail: '/imgweb/beauty_filter/beauty/nose/nose-reduce.svg',
        range: [0, 1],
      },
    },
  },
  lips: {
    id: 'lips',
    brscName: 'beauty_filter_mouth', // 입
    thumbnail: '/imgweb/beauty_filter/beauty/lip.svg',
    subKeys: ['size', 'height', 'thickness', 'smile', 'mouth_size'],
    subTable: {
      size: {
        id: 'size',
        brscName: 'beauty_filter_size', // 크기
        thumbnail: '/imgweb/beauty_filter/beauty/lips/lip-size.svg',
        range: [-1, 1],
      },
      height: {
        id: 'height',
        brscName: 'beauty_filter_height', // 높이
        thumbnail: '/imgweb/beauty_filter/beauty/lips/lip-position.svg',
        range: [-1, 1],
      },
      thickness: {
        id: 'thickness',
        brscName: 'beauty_filter_thickness', // 두께
        thumbnail: '/imgweb/beauty_filter/beauty/lips/bold-lip.svg',
        range: [-1, 1],
      },
      smile: {
        id: 'smile',
        brscName: 'beauty_filter_smile', // 미소
        thumbnail: '/imgweb/beauty_filter/beauty/lips/smile.svg',
        range: [0, 1],
      },
      mouth_size: {
        id: 'mouth_size',
        brscName: 'beauty_filter_breadth', // 너비
        thumbnail: '/imgweb/beauty_filter/beauty/lips/lip-weight.svg',
        range: [-1, 1],
      },
    },
  },
  eyebrows: {
    id: 'eyebrows',
    brscName: 'beauty_filter_brow', // 눈썹
    thumbnail: '/imgweb/beauty_filter/beauty/eyebrow.svg',
    subKeys: ['spacing', 'height', 'bend'],
    subTable: {
      spacing: {
        id: 'spacing',
        brscName: 'beauty_filter_spacing', // 간격
        thumbnail: '/imgweb/beauty_filter/beauty/eyebrows/eyebrow-spacing.svg',
        range: [-1, 1],
      },
      height: {
        id: 'height',
        brscName: 'beauty_filter_height', // 높이
        thumbnail: '/imgweb/beauty_filter/beauty/eyebrows/eyebrow-height.svg',
        range: [-1, 1],
      },
      bend: {
        id: 'bend',
        brscName: 'beauty_filter_angle', // 각도
        thumbnail: '/imgweb/beauty_filter/beauty/eyebrows/eyebrow-angle.svg',
        range: [-1, 1],
      },
    },
  },
};

const MAKEUP_TABLE: { [key: string]: MakeupItem } = {
  makeup_foundation: {
    id: 'makeup_foundation',
    brscName: 'beauty_filter_foundation', // 파운데이션
    thumbnail: '/imgweb/beauty_filter/makeup/foundation.svg',
    subKeys: ['Porcelain', 'PeachCream', 'SoftSand', 'HoneyBeige', 'Chestnut', 'DeepAmber', 'RichMocha'],
    subTable: {
      Porcelain: {
        id: 'Porcelain',
        name: 'Porcelain',
        thumbnail: '/imgweb/beauty_filter/makeup/foundation/Porcelain.png',
        range: [0, 1],
        banubaPrefabs: {
          color: '1.0 0.89 0.8',
          finish: 'natural',
        },
      },
      PeachCream: {
        id: 'PeachCream',
        name: 'PeachCream',
        thumbnail: '/imgweb/beauty_filter/makeup/foundation/PeachCream.png',
        range: [0, 1],
        banubaPrefabs: {
          color: '1.00 0.83 0.79',
          finish: 'natural',
        },
      },
      SoftSand: {
        id: 'SoftSand',
        name: 'SoftSand',
        thumbnail: '/imgweb/beauty_filter/makeup/foundation/SoftSand.png',
        range: [0, 1],
        banubaPrefabs: {
          color: '0.98 0.77 0.61',
          finish: 'natural',
        },
      },
      HoneyBeige: {
        id: 'HoneyBeige',
        name: 'HoneyBeige',
        thumbnail: '/imgweb/beauty_filter/makeup/foundation/HoneyBeige.png',
        range: [0, 1],
        banubaPrefabs: {
          color: '0.83 0.52 0.34',
          finish: 'natural',
        },
      },
      Chestnut: {
        id: 'Chestnut',
        name: 'Chestnut',
        thumbnail: '/imgweb/beauty_filter/makeup/foundation/Chestnut.png',
        range: [0, 1],
        banubaPrefabs: {
          color: '0.65 0.36 0.21',
          finish: 'natural',
        },
      },
      DeepAmber: {
        id: 'DeepAmber',
        name: 'DeepAmber',
        thumbnail: '/imgweb/beauty_filter/makeup/foundation/DeepAmber.png',
        range: [0, 1],
        banubaPrefabs: {
          color: '0.50 0.30 0.17',
          finish: 'natural',
        },
      },
      RichMocha: {
        id: 'RichMocha',
        name: 'RichMocha',
        thumbnail: '/imgweb/beauty_filter/makeup/foundation/RichMocha.png',
        range: [0, 1],
        banubaPrefabs: {
          color: '0.33 0.17 0.06',
          finish: 'natural',
        },
      },
    },
  },
  makeup_highlighter: {
    id: 'makeup_highlighter',
    brscName: 'beauty_filter_highlighter', // 하이라이터
    thumbnail: '/imgweb/beauty_filter/makeup/highlight.svg',
    subKeys: ['PearlWhite', 'RoseGold', 'Gold', 'Champagne'],
    subTable: {
      PearlWhite: {
        id: 'PearlWhite',
        name: 'PearlWhite',
        thumbnail: '',
        range: [0, 1],
        banubaPrefabs: {
          color: '0.95 0.95 0.95',
          finish: 'shimmer',
        },
      },
      RoseGold: {
        id: 'RoseGold',
        name: 'RoseGold',
        thumbnail: '',
        range: [0, 1],
        banubaPrefabs: {
          color: '0.90 0.80 0.83',
          finish: 'shimmer',
        },
      },
      Gold: {
        id: 'Gold',
        name: 'Gold',
        thumbnail: '',
        range: [0, 1],
        banubaPrefabs: {
          color: '0.92 0.85 0.70',
          finish: 'shimmer',
        },
      },
      Champagne: {
        id: 'Champagne',
        name: 'Champagne',
        thumbnail: '',
        range: [0, 1],
        banubaPrefabs: {
          color: '0.93 0.87 0.80',
          finish: 'shimmer',
        },
      },
    },
  },
  makeup_blush: {
    id: 'makeup_blush',
    brscName: 'beauty_filter_blush', // 블러셔
    thumbnail: '/imgweb/beauty_filter/makeup/blusher.svg',
    subKeys: ['CoralGlow', 'Tangerine', 'Blossom', 'Lavender', 'Red', 'Rose'],
    subTable: {
      CoralGlow: {
        id: 'CoralGlow',
        name: 'CoralGlow',
        thumbnail: '/imgweb/beauty_filter/makeup/blush/CoralGlow.png',
        range: [0, 1],
        banubaPrefabs: {
          color: '1.00 0.67 0.52',
          finish: 'shimmer',
        },
      },
      Tangerine: {
        id: 'Tangerine',
        name: 'Tangerine',
        thumbnail: '/imgweb/beauty_filter/makeup/blush/Tangerine.png',
        range: [0, 1],
        banubaPrefabs: {
          color: '1.00 0.50 0.17',
          finish: 'shimmer',
        },
      },
      Blossom: {
        id: 'Blossom',
        name: 'Blossom',
        thumbnail: '/imgweb/beauty_filter/makeup/blush/Blossom.png',
        range: [0, 1],
        banubaPrefabs: {
          color: '1.00 0.64 0.76',
          finish: 'shimmer',
        },
      },
      Lavender: {
        id: 'Lavender',
        name: 'Lavender',
        thumbnail: '/imgweb/beauty_filter/makeup/blush/Lavender.png',
        range: [0, 1],
        banubaPrefabs: {
          color: '0.70 0.42 0.71',
          finish: 'shimmer',
        },
      },
      Red: {
        id: 'Red',
        name: 'Red',
        thumbnail: '/imgweb/beauty_filter/makeup/blush/Red.png',
        range: [0, 1],
        banubaPrefabs: {
          color: '0.73 0.15 0.24',
          finish: 'shimmer',
        },
      },
      Rose: {
        id: 'Rose',
        name: 'Rose',
        thumbnail: '/imgweb/beauty_filter/makeup/blush/Rose.png',
        range: [0, 1],
        banubaPrefabs: {
          color: '0.90 0.45 0.45',
          finish: 'shimmer',
        },
      },
    },
  },
  makeup_eyeshadow: {
    id: 'makeup_eyeshadow',
    brscName: 'beauty_filter_eyeshadow', // 아이섀도우
    thumbnail: '/imgweb/beauty_filter/makeup/eyeshadow.svg',
    subKeys: ['Cinnamon', 'BrickRed', 'Mocha', 'BlushRose', 'BerryRed', 'PlumMist', 'RoyalBlue', 'Tangerine', 'Seafoam', 'Forest'],
    subTable: {
      Cinnamon: {
        id: 'Cinnamon',
        name: 'Cinnamon',
        thumbnail: '/imgweb/beauty_filter/makeup/eyeshadow/Cinnamon.png',
        range: [0, 1],
        banubaPrefabs: {
          color: '0.84 0.48 0.40',
          finish: 'matte',
        },
      },
      BrickRed: {
        id: 'BrickRed',
        name: 'BrickRed',
        thumbnail: '/imgweb/beauty_filter/makeup/eyeshadow/BrickRed.png',
        range: [0, 1],
        banubaPrefabs: {
          color: '0.76 0.32 0.26',
          finish: 'matte',
        },
      },
      Mocha: {
        id: 'Mocha',
        name: 'Mocha',
        thumbnail: '/imgweb/beauty_filter/makeup/eyeshadow/Mocha.png',
        range: [0, 1],
        banubaPrefabs: {
          color: '0.54 0.24 0.20',
          finish: 'shimmer',
        },
      },
      BlushRose: {
        id: 'BlushRose',
        name: 'BlushRose',
        thumbnail: '/imgweb/beauty_filter/makeup/eyeshadow/BlushRose.png',
        range: [0, 1],
        banubaPrefabs: {
          color: '0.78 0.44 0.48',
          finish: 'matte',
        },
      },
      BerryRed: {
        id: 'BerryRed',
        name: 'BerryRed',
        thumbnail: '/imgweb/beauty_filter/makeup/eyeshadow/BerryRed.png',
        range: [0, 1],
        banubaPrefabs: {
          color: '0.76 0.22 0.31',
          finish: 'matte',
        },
      },
      PlumMist: {
        id: 'PlumMist',
        name: 'PlumMist',
        thumbnail: '/imgweb/beauty_filter/makeup/eyeshadow/PlumMist.png',
        range: [0, 1],
        banubaPrefabs: {
          color: '0.45 0.20 0.33',
          finish: 'matte',
        },
      },
      RoyalBlue: {
        id: 'RoyalBlue',
        name: 'RoyalBlue',
        thumbnail: '/imgweb/beauty_filter/makeup/eyeshadow/RoyalBlue.png',
        range: [0, 1],
        banubaPrefabs: {
          color: '0.35 0.35 0.97',
          finish: 'matte',
        },
      },
      Tangerine: {
        id: 'Tangerine',
        name: 'Tangerine',
        thumbnail: '/imgweb/beauty_filter/makeup/eyeshadow/Tangerine.png',
        range: [0, 1],
        banubaPrefabs: {
          color: '0.98 0.41 0.00',
          finish: 'matte',
        },
      },
      Seafoam: {
        id: 'Seafoam',
        name: 'Seafoam',
        thumbnail: '/imgweb/beauty_filter/makeup/eyeshadow/Seafoam.png',
        range: [0, 1],
        banubaPrefabs: {
          color: '0.14 0.59 0.55',
          finish: 'matte',
        },
      },
      Forest: {
        id: 'Forest',
        name: 'Forest',
        thumbnail: '/imgweb/beauty_filter/makeup/eyeshadow/Forest.png',
        range: [0, 1],
        banubaPrefabs: {
          color: '0.13 0.45 0.20',
          finish: 'matte',
        },
      },
    },
  },
  makeup_eyebrows: {
    id: 'makeup_eyebrows',
    brscName: 'beauty_filter_eyebrow', // 아이브로우
    thumbnail: '/imgweb/beauty_filter/beauty/eyebrow.svg',
    subKeys: ['Charcoal', 'Espresso', 'Taupe', 'Amber', 'Chestnut', 'Mahogany', 'AshPlum'],
    subTable: {
      Charcoal: {
        id: 'Charcoal',
        name: 'Charcoal',
        thumbnail: '/imgweb/beauty_filter/makeup/eyebrows/Charcoal.png',
        range: [0, 1],
        banubaPrefabs: {
          color: '0.12 0.12 0.12',
          finish: 'matte',
        },
      },
      Espresso: {
        id: 'Espresso',
        name: 'Espresso',
        thumbnail: '/imgweb/beauty_filter/makeup/eyebrows/Espresso.png',
        range: [0, 1],
        banubaPrefabs: {
          color: '0.18 0.14 0.12',
          finish: 'matte',
        },
      },
      Taupe: {
        id: 'Taupe',
        name: 'Taupe',
        thumbnail: '/imgweb/beauty_filter/makeup/eyebrows/Taupe.png',
        range: [0, 1],
        banubaPrefabs: {
          color: '0.40 0.33 0.28',
          finish: 'matte',
        },
      },
      Amber: {
        id: 'Amber',
        name: 'Amber',
        thumbnail: '/imgweb/beauty_filter/makeup/eyebrows/Amber.png',
        range: [0, 1],
        banubaPrefabs: {
          color: '0.55 0.39 0.28',
          finish: 'matte',
        },
      },
      Chestnut: {
        id: 'Chestnut',
        name: 'Chestnut',
        thumbnail: '/imgweb/beauty_filter/makeup/eyebrows/Chestnut.png',
        range: [0, 1],
        banubaPrefabs: {
          color: '0.50 0.19 0.08',
          finish: 'matte',
        },
      },
      Mahogany: {
        id: 'Mahogany',
        name: 'Mahogany',
        thumbnail: '/imgweb/beauty_filter/makeup/eyebrows/Mahogany.png',
        range: [0, 1],
        banubaPrefabs: {
          color: '0.38 0.08 0.07',
          finish: 'matte',
        },
      },
      AshPlum: {
        id: 'AshPlum',
        name: 'AshPlum',
        thumbnail: '/imgweb/beauty_filter/makeup/eyebrows/AshPlum.png',
        range: [0, 1],
        banubaPrefabs: {
          color: '0.27 0.20 0.24',
          finish: 'matte',
        },
      },
    },
  },
  makeup_lipstick: {
    id: 'makeup_lipstick',
    brscName: 'beauty_filter_lipstick', // 립스틱
    thumbnail: '/imgweb/beauty_filter/makeup/lipstick.svg',
    subKeys: ['SoftPetal', 'RoseFlame', 'PinkRush', 'BerryKiss', 'Scarlet', 'Velvet', 'FieryCoral', 'SpicedRed', 'RubyBloom', 'PlumWine'],
    subTable: {
      SoftPetal: {
        id: 'SoftPetal',
        name: 'SoftPetal',
        thumbnail: '/imgweb/beauty_filter/makeup/lipstick/SoftPetal.png',
        range: [0, 1],
        banubaPrefabs: {
          color: '0.95 0.60 0.62',
          finish: 'shimmer',
        },
      },
      RoseFlame: {
        id: 'RoseFlame',
        name: 'RoseFlame',
        thumbnail: '/imgweb/beauty_filter/makeup/lipstick/RoseFlame.png',
        range: [0, 1],
        banubaPrefabs: {
          color: '0.98 0.34 0.35',
          finish: 'shimmer',
        },
      },
      PinkRush: {
        id: 'PinkRush',
        name: 'PinkRush',
        thumbnail: '/imgweb/beauty_filter/makeup/lipstick/PinkRush.png',
        range: [0, 1],
        banubaPrefabs: {
          color: '0.99 0.36 0.59',
          finish: 'shimmer',
        },
      },
      BerryKiss: {
        id: 'BerryKiss',
        name: 'BerryKiss',
        thumbnail: '/imgweb/beauty_filter/makeup/lipstick/BerryKiss.png',
        range: [0, 1],
        banubaPrefabs: {
          color: '1.00 0.17 0.42',
          finish: 'shimmer',
        },
      },
      Scarlet: {
        id: 'Scarlet',
        name: 'Scarlet',
        thumbnail: '/imgweb/beauty_filter/makeup/lipstick/Scarlet.png',
        range: [0, 1],
        banubaPrefabs: {
          color: '0.90 0.00 0.04',
          finish: 'shimmer',
        },
      },
      Velvet: {
        id: 'Velvet',
        name: 'Velvet',
        thumbnail: '/imgweb/beauty_filter/makeup/lipstick/Velvet.png',
        range: [0, 1],
        banubaPrefabs: {
          color: '0.72 0.00 0.04',
          finish: 'shimmer',
        },
      },
      FieryCoral: {
        id: 'FieryCoral',
        name: 'FieryCoral',
        thumbnail: '/imgweb/beauty_filter/makeup/lipstick/FieryCoral.png',
        range: [0, 1],
        banubaPrefabs: {
          color: '0.93 0.25 0.00',
          finish: 'shimmer',
        },
      },
      SpicedRed: {
        id: 'SpicedRed',
        name: 'SpicedRed',
        thumbnail: '/imgweb/beauty_filter/makeup/lipstick/SpicedRed.png',
        range: [0, 1],
        banubaPrefabs: {
          color: '0.67 0.19 0.00',
          finish: 'shimmer',
        },
      },
      RubyBloom: {
        id: 'RubyBloom',
        name: 'RubyBloom',
        thumbnail: '/imgweb/beauty_filter/makeup/lipstick/RubyBloom.png',
        range: [0, 1],
        banubaPrefabs: {
          color: '0.84 0.06 0.40',
          finish: 'shimmer',
        },
      },
      PlumWine: {
        id: 'PlumWine',
        name: 'PlumWine',
        thumbnail: '/imgweb/beauty_filter/makeup/lipstick/PlumWine.png',
        range: [0, 1],
        banubaPrefabs: {
          color: '0.46 0.17 0.33',
          finish: 'shimmer',
        },
      },
    },
  },
};

const MOOD_TABLE: { [key: string]: MoodItem } = {
  se_none: {
    id: 'se_none',
    name: '',
    thumbnail: '',
    settings: {},
    versionInfo: {},
  },
  se_hudson: {
    id: 'se_hudson',
    name: 'Clear',
    thumbnail: '/imgweb/beauty_filter/mood/_0000_clear.jpg_0013_clear.jpg',
    settings: {
      glslurl: '/androidmain/res/raw/rgb_beautify.glsl',
    },
    versionInfo: {},
  },
  be_default: {
    id: 'be_default',
    name: 'Natural',
    thumbnail: '/imgweb/beauty_filter/mood/_0000_clear.jpg_0012_natural.jpg',
    settings: {},
    versionInfo: {},
  },
  se_walden: {
    id: 'se_walden',
    name: 'Vintage',
    thumbnail: '/imgweb/beauty_filter/mood/_0000_clear.jpg_0011_vintage.jpg',
    settings: {},
    versionInfo: {},
  },
  se_fairytale: {
    id: 'se_fairytale',
    name: 'White',
    thumbnail: '/imgweb/beauty_filter/mood/_0000_clear.jpg_0010_white.jpg',
    settings: {},
    versionInfo: {},
  },
  se_brannan: {
    id: 'se_brannan',
    name: 'Cinematic',
    thumbnail: '/imgweb/beauty_filter/mood/_0000_clear.jpg_0009_cinematic.jpg',
    settings: {
      glslurl: '/androidmain/res/raw/rgb_beautifybrannan.glsl',
      tex1: '/androidmain/assets/filter/brannan_process.png',
      tex2: '/androidmain/assets/filter/brannan_blowout.png',
      tex3: '/androidmain/assets/filter/brannan_contrast.png',
      tex4: '/androidmain/assets/filter/brannan_luma.png',
      tex5: '/androidmain/assets/filter/brannan_screen.png',
    },
    versionInfo: {},
  },
  se_1977: {
    id: 'se_1977',
    name: 'Peach',
    thumbnail: '/imgweb/beauty_filter/mood/_0000_clear.jpg_0008_peach.jpg',
    settings: {
      glslurl: '/androidmain/res/raw/rgb_beautifyromance.glsl',
      tex1: '/androidmain/assets/filter/romance_curves.png',
    },
    versionInfo: {},
  },
  se_toaster2: {
    id: 'se_toaster2',
    name: 'Cloud',
    thumbnail: '/imgweb/beauty_filter/mood/_0000_clear.jpg_0007_cloud.jpg',
    settings: {
      glslurl: '/androidmain/res/raw/rgb_beautifyhealthy.glsl',
      tex1: '/androidmain/assets/filter/healthy_curves.png',
      tex2: '/androidmain/assets/filter/healthy_mask_1.jpg',
    },
    versionInfo: {},
  },
  se_rise: {
    id: 'se_rise',
    name: 'Dust',
    thumbnail: '/imgweb/beauty_filter/mood/_0000_clear.jpg_0006_dust.jpg',
    settings: {},
    versionInfo: {},
  },
  se_skinwhiten: {
    id: 'se_skinwhiten',
    name: 'Hazy',
    thumbnail: '/imgweb/beauty_filter/mood/_0000_clear.jpg_0005_hazy.jpg',
    settings: {},
    versionInfo: {},
  },
  se_amaro: {
    id: 'se_amaro',
    name: '',
    thumbnail: '',
    settings: {},
    versionInfo: { max: { aver: 160, iver: 121 } },
  },
  se_nashville: {
    id: 'se_nashville',
    name: '',
    thumbnail: '',
    settings: {},
    versionInfo: { max: { aver: 160, iver: 121 } },
  },
  se_earlybird: {
    id: 'se_earlybird',
    name: '',
    thumbnail: '',
    settings: {},
    versionInfo: { max: { aver: 160, iver: 121 } },
  },
  se_kelvin: {
    id: 'se_kelvin',
    name: '',
    thumbnail: '',
    settings: {},
    versionInfo: { max: { aver: 160, iver: 121 } },
  },
  se_toaster: {
    id: 'se_toaster',
    name: '',
    thumbnail: '',
    settings: {},
    versionInfo: { max: { aver: 160, iver: 121 } },
  },
  se_sepia: {
    id: 'se_sepia',
    name: '',
    thumbnail: '',
    settings: {},
    versionInfo: { max: { aver: 160, iver: 121 } },
  },
  se_inkwell: {
    id: 'se_inkwell',
    name: 'B&W',
    thumbnail: '/imgweb/beauty_filter/mood/_0000_clear.jpg_0004_bw.jpg',
    settings: {},
    versionInfo: {},
  },
  se_sketch: {
    id: 'se_sketch',
    name: '',
    thumbnail: '',
    settings: { glslurl: '/androidmain/res/raw/rgb_sketch_filter.glsl' },
    versionInfo: { max: { aver: 160, iver: 121 } },
  },
  se_crayon: {
    id: 'se_crayon',
    name: '',
    thumbnail: '',
    settings: { glslurl: '/androidmain/res/raw/rgb_crayon_filter.glsl' },
    versionInfo: { max: { aver: 160, iver: 121 } },
  },
  se_snow_disposablecamera: {
    id: 'se_snow_disposablecamera',
    name: 'Instax',
    thumbnail: '/imgweb/beauty_filter/mood/_0000_clear.jpg_0003_instax.jpg',
    settings: {
      replace: {
        'BEAUTIFY [01]': 'BEAUTIFY 0',
        'OPACITY [0-9.]*': 'OPACITY 0.2',
      },
    },
    versionInfo: { min: { aver: 161, iver: 122 } },
  },
  se_snow_toycamera: {
    id: 'se_snow_toycamera',
    name: 'Fog',
    thumbnail: '/imgweb/beauty_filter/mood/_0000_clear.jpg_0002_fog.jpg',
    settings: {
      replace: {
        'BEAUTIFY [01]': 'BEAUTIFY 0',
        'OPACITY [0-9.]*': 'OPACITY 0.8',
      },
    },
    versionInfo: { min: { aver: 161, iver: 122 } },
  },
  se_snow_filmblue: {
    id: 'se_snow_filmblue',
    name: 'Dawn',
    thumbnail: '/imgweb/beauty_filter/mood/_0000_clear.jpg_0001_dawn.jpg',
    settings: {
      replace: {
        'BEAUTIFY [01]': 'BEAUTIFY 0',
        'OPACITY [0-9.]*': 'OPACITY 0.2',
      },
    },
    versionInfo: { min: { aver: 161, iver: 122 } },
  },
  se_snow_filmold: {
    id: 'se_snow_filmold',
    name: 'Gloomy',
    thumbnail: '/imgweb/beauty_filter/mood/_0000_clear.jpg_0000_gloomy.jpg',
    settings: {
      replace: {
        'BEAUTIFY [01]': 'BEAUTIFY 0',
        'OPACITY [0-9.]*': 'OPACITY 0.4',
      },
    },
    versionInfo: { min: { aver: 161, iver: 122 } },
  },
  se_blurbox: {
    id: 'se_blurbox',
    name: '',
    thumbnail: '',
    settings: {
      glslurl: '/androidmain/res/raw/rgb_blurbox.glsl',
      /* From Androidd V109 replace로 glsl value변경 가능
          replace: {
              "THRESHOLD 0.02": "THRESHOLD 0.02",
              "GRANULARITY 2": "GRANULARITY 2",
          },
      */
    },
    versionInfo: {},
  },
  se_blurbias: {
    id: 'se_blurbias',
    name: '',
    thumbnail: '',
    settings: {
      glslurl: '/androidmain/res/raw/rgb_blurbias.glsl',
      replace: {
        'BLURBIAS [0-9]*': 'BLURBIAS 75',
      },
    },
    versionInfo: {},
  },
  face_blurbias: {
    id: 'face_blurbias',
    name: '',
    thumbnail: '',
    settings: {
      replace: {
        'BLURBIAS [0-9]*': 'BLURBIAS 75',
      },
      option: {
        faceHeightWeight: '1.9',
        // by jhh, 240707
        // 얼굴 중심에서 위쪽으로 n배 증가(0은 안됨)
        // faceHeightWeight를 덮어씀
        faceUpWeight: '10.0',
      },
    },
    versionInfo: {},
  },
  se_blurmipmap: {
    id: 'se_blurmipmap',
    name: '',
    thumbnail: '',
    settings: {
      glslurl: '/androidmain/res/raw/rgb_blurmipmap.glsl',
      replace: {
        'BLURRADIUS [0-9]*': 'BLURRADIUS 75',
      },
    },
    versionInfo: {},
  },
  se_shadertest: {
    id: 'se_shadertest',
    name: '',
    thumbnail: '',
    settings: {
      glslurl: '/test/rgb_shadertest.glsl',
      replace: {
        'TEST [0-9]*': 'TEST 75',
      },
    },
    versionInfo: {},
  },
};

const STICKER_TABLE: { [key: string]: StickerItem } = {
  bling_rabbit: {
    id: 'bling_rabbit',
    thumbnail: '/imgweb/sticker_thumb9/bling_rabbit.png',
  },
  freckles_bungirl: {
    id: 'freckles_bungirl',
    thumbnail: '/imgweb/sticker_thumb9/freckles_bungirl.png',
  },
  mini_flower_coronet: {
    id: 'mini_flower_coronet',
    thumbnail: '/imgweb/sticker_thumb9/mini_flower_coronet.png',
  },
  cute_choco_hair: {
    id: 'cute_choco_hair',
    thumbnail: '/imgweb/sticker_thumb9/cute_choco_hair.png',
  },
  think: {
    id: 'think',
    thumbnail: '/imgweb/sticker_thumb9/think.png',
  },
  christmas_cat: {
    id: 'christmas_cat',
    thumbnail: '/imgweb/sticker_thumb9/christmas_cat.png',
  },
  christmas_snow: {
    id: 'christmas_snow',
    thumbnail: '/imgweb/sticker_thumb9/christmas_snow.png',
  },
  marker_dog: {
    id: 'marker_dog',
    thumbnail: '/imgweb/sticker_thumb9/marker_dog.png',
  },
  cn_black_line_cat: {
    id: 'cn_black_line_cat',
    thumbnail: '/imgweb/sticker_thumb9/cn_black_line_cat.png',
  },
  cn_white_choker_tiger_no_choker: {
    id: 'cn_white_choker_tiger_no_choker',
    thumbnail: '/imgweb/sticker_thumb9/cn_white_choker_tiger_no_choker.png',
  },
  floral_pattern_cat: {
    id: 'floral_pattern_cat',
    thumbnail: '/imgweb/sticker_thumb9/floral_pattern_cat.png',
  },
  cherry_blossom_rabbit: {
    id: 'cherry_blossom_rabbit',
    thumbnail: '/imgweb/sticker_thumb9/cherry_blossom_rabbit.png',
  },
  rabbit_meitu: {
    id: 'rabbit_meitu',
    thumbnail: '/imgweb/sticker_thumb9/rabbit_meitu.png',
  },
  red_nose_rabbit: {
    id: 'red_nose_rabbit',
    thumbnail: '/imgweb/sticker_thumb9/red_nose_rabbit.png',
  },
  transperency_pink_neon_rabbit: {
    id: 'transperency_pink_neon_rabbit',
    thumbnail: '/imgweb/sticker_thumb9/transperency_pink_neon_rabbit.png',
  },
  mint_rabbit: {
    id: 'mint_rabbit',
    thumbnail: '/imgweb/sticker_thumb9/mint_rabbit.png',
  },
  mirrorball_bear: {
    id: 'mirrorball_bear',
    thumbnail: '/imgweb/sticker_thumb9/mirrorball_bear.png',
  },
  wolfgang: {
    id: 'wolfgang',
    thumbnail: '/imgweb/sticker_thumb9/wolfgang.png',
  },
  dandelion_corolla: {
    id: 'dandelion_corolla',
    thumbnail: '/imgweb/sticker_thumb9/dandelion_corolla.png',
  },
  heart_waterdrop_mouse: {
    id: 'heart_waterdrop_mouse',
    thumbnail: '/imgweb/sticker_thumb9/heart_waterdrop_mouse.png',
  },
  fruit_line_cat: {
    id: 'fruit_line_cat',
    thumbnail: '/imgweb/sticker_thumb9/fruit_line_cat.png',
  },
  glassesdrawing: {
    id: 'glassesdrawing',
    thumbnail: '/imgweb/sticker_thumb9/glassesdrawing.png',
  },
  love_cheek: {
    id: 'love_cheek',
    thumbnail: '/imgweb/sticker_thumb9/love_cheek.png',
  },
  marker_tiny_hearts: {
    id: 'marker_tiny_hearts',
    thumbnail: '/imgweb/sticker_thumb9/marker_tiny_hearts.png',
  },
  pink_heart_blush: {
    id: 'pink_heart_blush',
    thumbnail: '/imgweb/sticker_thumb9/pink_heart_blush.png',
  },
  lip_orange: {
    id: 'lip_orange',
    thumbnail: '/imgweb/sticker_thumb9/lip_orange.png',
  },
  lip_pink: {
    id: 'lip_pink',
    thumbnail: '/imgweb/sticker_thumb9/lip_pink.png',
  },
  lip_red: {
    id: 'lip_red',
    thumbnail: '/imgweb/sticker_thumb9/lip_red.png',
  },
};

const BACKGROUND_TABLE: { [key: string]: BackgroundItem } = {
  Blur: {
    id: 'Blur',
    name: 'Blur',
    thumbnail: '/imgweb/filter/background/Blur.png',
    banubaPrefabs: {
      blur: 0.5,
    },
  },
  HOME01: {
    id: 'Home01',
    name: 'Home01',
    thumbnail: '/imgweb/filter/background/Home01.png',
    banubaPrefabs: {
      texture: 'background/Home01.png',
      content_mode: 'fit',
    },
  },
  HOME02: {
    id: 'Home02',
    name: 'Home02',
    thumbnail: '/imgweb/filter/background/Home02.png',
    banubaPrefabs: {
      texture: 'background/Home02.png',
      content_mode: 'fit',
    },
  },
};

const BEAUTY_FILTER_MENU_ITEMS_ALL: BeautyFilterMenuItem[] = [
  {
    id: 'beauty',
    brscName: 'beauty_filter_beauty', // 뷰티
    thumbnail: '/imgweb/beauty_filter/menu/beauty.svg',
    notSupportedOnWeb: true,
    requiresBanuba: true,
  },
  {
    id: 'makeup',
    brscName: 'beauty_filter_makeup', // 메이크업
    thumbnail: '/imgweb/beauty_filter/menu/makeup.svg',
    notSupportedOnWeb: true,
    requiresBanuba: true,
  },
  {
    id: 'mood',
    brscName: 'beauty_filter_mood', // 무드
    thumbnail: '/imgweb/beauty_filter/menu/mood.svg',
  },
  {
    id: 'sticker',
    brscName: 'beauty_filter_sticker', // 스티커
    thumbnail: '/imgweb/beauty_filter/menu/sticker.svg',
    notSupportedOnWeb: true,
  },
  // {
  //   id: 'background',
  //   brscName: 'beauty_filter_background',
  //   value: 'Background',
  //   thumbnail: '/imgweb/beauty_filter/menu/background.svg',
  // },
];

/** 웹+모바일이면 notSupportedOnWeb 메뉴 숨김 (네이티브 구현 필요) */
const BEAUTY_FILTER_MENU_ITEMS: BeautyFilterMenuItem[] = (() => {
  const isWebMobile = Device?.name === 'web' && (getUserAgentInfo?.())?.isMobile;
  return isWebMobile ? BEAUTY_FILTER_MENU_ITEMS_ALL.filter((item) => !item.notSupportedOnWeb) : BEAUTY_FILTER_MENU_ITEMS_ALL;
})();

export { BEAUTY_KEYS, MAKEUP_KEYS, MOOD_KEYS, STICKER_KEYS, BACKGROUND_KEYS, BEAUTY_TABLE, MAKEUP_TABLE, MOOD_TABLE, STICKER_TABLE, BACKGROUND_TABLE, BEAUTY_FILTER_MENU_ITEMS };
